<template>
  <Navbar/>
  <div class="p-4">
    <div class="d-flex mb-4 text-darker justify-content-evenly">
      <a href="#" class="text-secondary text-decoration-none">
        <i class="fas fa-search"></i> Szukaj
      </a>
      <a href="#" class="text-primary text-decoration-none">
        <i class="fas fa-sync"></i> Odśwież
      </a>
    </div>
    <hr>
    <h2 class="text-center">Dodaj nowe miejsce</h2>
    <form @submit.prevent="postPlace">
      <div class="mb-3">
        <label for="place-name" class="form-label">Nazwa</label>
        <input type="text" class="form-control" id="place-name" v-model="acronym">
      </div>
      <div class="mb-3">
        <label for="place-short-name" class="form-label">Nazwa skrócona</label>
        <input type="text" class="form-control" id="place-short-name" v-model="acronym">
      </div>
      <div class="mb-3">
        <label for="place-address" class="form-label">Adres</label>
        <input type="text" class="form-control" id="place-address" @input="updatePositions" v-model="address">
      </div>
      <div class="mb-3">
        <label for="place-suggestion" class="form-label">Podpowiedzi</label>
        <select id="place-suggestion" class="form-control" v-model="suggestion" @change="setBounds($event)" @input="setBounds($event)" @option:select="setBounds($event)">
          <option v-for="(suggestion, key) in this.suggestions.results" :key="key" :value="`${suggestion.geometry.location.lat}_${suggestion.geometry.location.lng}`">
            {{ suggestion.formatted_address }}
          </option>
        </select>
      </div>
      <div class="mb-3">
        <label for="place-positions" class="form-label">Współrzędne</label>
        <input id="place-positions" type="text" class="form-control" :value="`${positionLatitude},${positionLongitude}`">
      </div>
      <div class="mb-3">
        <label for="place-description" class="form-label">Opis miejsca</label>
        <textarea name="description" class="form-control" id="place-description" rows="10" v-model="description"></textarea>
      </div>
      <button type="submit" class="btn btn-primary">Zatwierdź</button>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import Navbar from '@/components/Navbar'

export default {
  name: 'CreatePlace',
  components: { Navbar },
  data () {
    return {
      positionLatitude: null,
      positionLongitude: null,
      positions: '',
      suggestion: '',
      suggestions: [],
      currentSuggestion: null,
      address: '',
      acronym: ''
    }
  },
  mounted () {
    if (this.$route.params.acronym !== undefined) {
      this.acronym = this.$route.params.acronym
    }
  },
  methods: {
    postPlace () {
      const Pnamee = document.querySelector('#place-name').value
      const PnameeShort = document.querySelector('#place-short-name').value
      const Paddress = document.querySelector('#place-address').value
      const Pdescription = document.querySelector('#place-description').value
      const PLatitude = document.querySelector('#place-positions').value.split(',')[0]
      const PLongitude = document.querySelector('#place-positions').value.split(',')[1]
      if (Pnamee === '' || PnameeShort === '' || Paddress === '' || Pdescription === '') {
        Swal.fire('wprowadź wszystkie dane', '', 'error')
      } else {
        var myHeaders = new Headers()
        myHeaders.append('Content-Type', 'application/json')
        myHeaders.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`)
        myHeaders.append('Accept', '*/*')
        myHeaders.append('contentType', 'application/json-patch+json')

        var raw = JSON.stringify([{
          name: Pnamee.trim(),
          acronym: PnameeShort.trim(),
          address: Paddress.trim(),
          positionLatitude: PLatitude,
          positionLongitude: PLongitude,
          description: Pdescription
        }])
        // raw = [Pnamee, PnameeShort, Paddress, this.positionLatitude, this.positionLongitude, Pdescription]

        // raw = new Set ([Pnamee, PnameeShort, Paddress, this.positionLatitude, this.positionLongitude, Pdescription])
        // var raw2 = []
        // raw = `["${Pnamee}","${PnameeShort}","${Paddress}","${this.positionLatitude}","${this.positionLongitude}","${Pdescription}"]`
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow'
        }

        fetch(`${process.env.VUE_APP_API_BASE_URL}Place`, requestOptions)
          .then(response => response.text())
          .then(result => {
            console.log(result)
            Swal.fire('Pomyślnie dodano miejsce', '', 'success')
            this.$router.push('/miejsca')
          })
          .catch(error => {
            console.log('error', error)
            Swal.fire('Coś poszło nie tak', '', 'error')
          })
      }
    },
    updatePositions () {
      const urlEncodedAddress = encodeURI(this.address)
      const apiUrl = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + urlEncodedAddress + '&key=AIzaSyDYAQTlVi1D2Yrr2KsWv6Ql4kCPeUhDyic'

      axios.get(apiUrl).then(response => {
        this.suggestions = response.data
      }).catch(error => {
        console.log(error)
      })
    },
    setBounds (event) {
      this.positionLatitude = event.target.value.split('_')[0]
      this.positionLongitude = event.target.value.split('_')[1]
    }
  }
}
</script>
